import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

const DashboardIcon = (props) => (
  <SvgIcon {...props}>
    <path d="M16.987 19.979a.942.942 0 01-.998-.998v-8.976a.942.942 0 01.998-.997h1.994a.942.942 0 01.998.997v8.976a.942.942 0 01-.998.998zm-5.984 0a.941.941 0 01-.998-.998V5.02a.942.942 0 01.998-.998h1.994a.942.942 0 01.998.998V18.98a.941.941 0 01-.998.998zm-5.984 0a.942.942 0 01-.998-.998v-3.989a.942.942 0 01.998-.997h1.994a.943.943 0 01.998.997v3.99a.942.942 0 01-.998.997z" />
  </SvgIcon>
);
DashboardIcon.displayName = 'DashboardIcon';
DashboardIcon.muiName = 'SvgIcon';

export default DashboardIcon;
